import React, { useRef } from "react";
import PrzegladPodsumowanieA4 from "./PrzegladPodsumowanieA4";
import WynikiGlosowaniaA4Buttons from "./WynikiGlosowaniaA4Buttons";
                
const PrzegladPodsumowanieWydrukModal = props => {

    const { handlePodsumowanie, activeCard, tablicaMieszkancyUdzialy, wspolnota } = props;

    const handleModalClick = (event) => event.stopPropagation();

    const componentRef = useRef();

    return (
        <div
            className="glosowanieWydruk" 
            onClick={handlePodsumowanie}
        >
            <div className="modal" onClick={handleModalClick}>
                <PrzegladPodsumowanieA4
                    componentRef={componentRef}
                    tablicaMieszkancyUdzialy={tablicaMieszkancyUdzialy}
                    activeCard={activeCard}
                    wspolnota={wspolnota}
                />
                <WynikiGlosowaniaA4Buttons
                    componentRef={componentRef}
                    showPrint={handlePodsumowanie}
                />
            </div>
        </div>
    )
}

export default PrzegladPodsumowanieWydrukModal;